export enum UserColumnFilterType {
  TextRadio = 'text-radio',
  TextSelection = 'text-selection',
  TextCheckbox = 'text-checkbox',
  TextSegmented = 'text-segmented',
  NumberSelection = 'num-selection',
  NumberExactAmount = 'num-exact-amount',
  NumberRange = 'num-range',
  DateExactDate = 'date-exact-date',
  DateDateRange = 'date-date-range',
  RatingAmountWithin = 'rating-amount-within',
  RatingAtLeast = 'rating-at-least',
  BooleanToggle = 'bool-toggle',
  ContentNotEmpty = 'content-not-empty',
}

export interface UserColumnFilterValue {
  column: string
  label?: string
  filterType: UserColumnFilterType
  icon?: string
  multiple: boolean
  showOnPage: boolean
  showOnFilter: boolean
}
